export const itemsRoutes = {
  list: '/admin/check',
  checkIn: '/admin/check/in',
  checkInAuth: '/admin/check/auth/check-in',
  checkInAdmin: '/admin/check/in-admin',  
};
